


































import { Vue, Prop, Watch } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import CookieMixin from '@/mixins/cookie';

import Number from '@/components/Atoms/Input/Number.vue';
import NumberWithoutValidator from '@/components/Atoms/Input/NumberWithoutValidator.vue';
import PlusButton from '@/components/Atoms/Button/PlusButton.vue';
import MinusButton from '@/components/Atoms/Button/MinusButton.vue';

@Component({
  components: {
    Number,
    NumberWithoutValidator,
    PlusButton,
    MinusButton,
  },
})
export default class ProductCount extends mixins(CookieMixin) {
  @Prop() payload!: { [key: string]: string };
  @Prop() private namespace!: string;
  @Prop({ default: 'M' }) private buttonSize!: 'S' | 'M';
  // スマートデバイスから閲覧した際、全ての要素を一行で表示するかどうか
  @Prop({ default: false }) private isOneLineForSd?: boolean;
  @Prop({ default: undefined }) validateRules?: string;
  @Prop({ default: 999 }) maxValue?: number;
  count = 0;

  mounted() {
    this.count = this.findNumber(this.payload);
  }

  get buttonClass(): string {
    switch (this.buttonSize) {
      case 'S':
        return 'small';
      case 'M':
        return 'medium';
      default:
        return '';
    }
  }

  get existValidateRules(): boolean {
    return this.validateRules != undefined;
  }

  get isAddable(): boolean {
    return this.maxValue == undefined ? true : this.count < this.maxValue;
  }

  update(newVal: string) {
    this.count = parseInt(newVal);
  }

  decrement() {
    if (this.count > 0) {
      --this.count;
    }
  }

  increment() {
    ++this.count;
  }

  @Watch('count')
  onCountChanged(newVal: string, oldVal: string) {
    const num = parseInt(newVal);
    this.$emit('updateCount', num);
    this.save(num);
  }

  save(val: number) {
    this.$store.commit(
      `${this.namespace}/update`,
      Object.assign({}, this.payload, { count: val })
    );
    this.saveValue(this.payload, val);
  }
}
